import { render } from "./DepositNotification.vue?vue&type=template&id=f585c80c&scoped=true"
import script from "./DepositNotification.vue?vue&type=script&lang=js"
export * from "./DepositNotification.vue?vue&type=script&lang=js"

import "./DepositNotification.vue?vue&type=style&index=0&id=f585c80c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f585c80c"]])

export default __exports__